import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { ExpenseItem } from '../entities/app/job/expense';
import { InvoiceItem } from '../entities/app/job/invoice';
import { Context } from '../entities/app/context/session';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  enrichedAddress?: Maybe<EnrichedAddress>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AnalysisFieldValue = {
  __typename?: 'AnalysisFieldValue';
  boundingBox?: Maybe<BoundingBox>;
  confidence?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bankName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutionNumber?: Maybe<Scalars['String']['output']>;
  maskedAccountNumber: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  transitNumber?: Maybe<Scalars['String']['output']>;
};

export type Bid = {
  __typename?: 'Bid';
  amount: Scalars['Float']['output'];
  contractor: ContractorPublicProfile;
  id: Scalars['ID']['output'];
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height?: Maybe<Scalars['Float']['output']>;
  left?: Maybe<Scalars['Float']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Charge = {
  __typename?: 'Charge';
  chargeBreakdown: ChargeBreakdown;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  taxBreakdown: TaxBreakdown;
  totalChargedAmount: Scalars['Float']['output'];
};

export type ChargeBreakdown = {
  __typename?: 'ChargeBreakdown';
  contractorFee: Scalars['Float']['output'];
  systemFee: Scalars['Float']['output'];
};

export type ContractorProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type ContractorPublicProfile = {
  __typename?: 'ContractorPublicProfile';
  bio?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  pictureUri?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<RatingSummary>;
};

export type EchoResponse = {
  __typename?: 'EchoResponse';
  echo: Scalars['String']['output'];
};

export type EmbeddedUrl = {
  __typename?: 'EmbeddedUrl';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EnrichedAddress = {
  __typename?: 'EnrichedAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  county?: Maybe<Scalars['String']['output']>;
  formatted: Scalars['String']['output'];
  housenumber?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  postcode: Scalars['String']['output'];
  rank: EnrichedAddressRank;
  state: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  suburb?: Maybe<Scalars['String']['output']>;
};

export type EnrichedAddressRank = {
  __typename?: 'EnrichedAddressRank';
  match_type: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  analysis?: Maybe<ExpenseAnalysis>;
  id: Scalars['ID']['output'];
  invoiceAmount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  presignedDownloadFile: Scalars['String']['output'];
  presignedUploadFile: Scalars['String']['output'];
  type: ExpenseType;
};

export type ExpenseAnalysis = {
  __typename?: 'ExpenseAnalysis';
  pages: Array<ExpenseAnalysisPage>;
  status: ExpenseAnalysisStatus;
};

export type ExpenseAnalysisPage = {
  __typename?: 'ExpenseAnalysisPage';
  amountDue?: Maybe<AnalysisFieldValue>;
  amountPaid?: Maybe<AnalysisFieldValue>;
  date?: Maybe<AnalysisFieldValue>;
  id?: Maybe<AnalysisFieldValue>;
  lineItems: Array<ExpenseLineItem>;
  pageNumber: Scalars['Int']['output'];
  tax?: Maybe<AnalysisFieldValue>;
  vendor?: Maybe<ExpenseVendor>;
};

export enum ExpenseAnalysisStatus {
  Error = 'ERROR',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Succeeded = 'SUCCEEDED'
}

export type ExpenseCreateInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  invoiceAmount: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum ExpenseFilter {
  All = 'ALL',
  NotInvoiced = 'NOT_INVOICED'
}

export type ExpenseLineItem = {
  __typename?: 'ExpenseLineItem';
  description?: Maybe<AnalysisFieldValue>;
  price?: Maybe<AnalysisFieldValue>;
  productCode?: Maybe<AnalysisFieldValue>;
  quantity?: Maybe<AnalysisFieldValue>;
  row?: Maybe<AnalysisFieldValue>;
  unitPrice?: Maybe<AnalysisFieldValue>;
};

export enum ExpenseType {
  System = 'SYSTEM',
  UserFile = 'USER_FILE',
  UserManual = 'USER_MANUAL'
}

export type ExpenseUpdateInput = {
  invoiceAmount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseVendor = {
  __typename?: 'ExpenseVendor';
  address?: Maybe<AnalysisFieldValue>;
  name?: Maybe<AnalysisFieldValue>;
};

export enum GenderEnum {
  Female = 'Female',
  Male = 'Male'
}

export type Invoice = {
  __typename?: 'Invoice';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expenses: Array<Expense>;
  id: Scalars['ID']['output'];
  invoiceFinalizedAt?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['String']['output'];
  payBy?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<Charge>>>;
  status: InvoiceStatus;
};

export enum InvoiceStatus {
  Editing = 'EDITING',
  Finalized = 'FINALIZED',
  FundsDelivered = 'FUNDS_DELIVERED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  SentToPayor = 'SENT_TO_PAYOR',
  Submitted = 'SUBMITTED',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export type InvoiceUpdateInput = {
  addExpenses?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeExpenses?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<InvoiceStatus>;
};

export type Job = {
  __typename?: 'Job';
  awardedTo?: Maybe<ContractorPublicProfile>;
  awardedToId?: Maybe<Scalars['ID']['output']>;
  bids?: Maybe<Array<Maybe<Bid>>>;
  chargeType: JobChargeModel;
  charges?: Maybe<Array<Maybe<Charge>>>;
  customerReview?: Maybe<JobReview>;
  description?: Maybe<Scalars['String']['output']>;
  destinationAddress?: Maybe<Address>;
  expenses: Array<Expense>;
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  jobCategory: JobCategoryEnum;
  jobEndDate?: Maybe<Scalars['String']['output']>;
  jobEndTime?: Maybe<Scalars['String']['output']>;
  jobStartDate: Scalars['String']['output'];
  jobStartDateTimeIso: Scalars['String']['output'];
  jobStartTime: Scalars['String']['output'];
  jobStatus: JobStatusEnum;
  messages?: Maybe<Array<Maybe<Message>>>;
  metrics?: Maybe<JobMetrics>;
  originAddress: Address;
  owner: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  people?: Maybe<Array<Maybe<People>>>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  winningBid?: Maybe<Bid>;
};


export type JobExpensesArgs = {
  filter?: InputMaybe<ExpenseFilter>;
};


export type JobInvoicesArgs = {
  status?: InputMaybe<InvoiceStatus>;
};

export type JobAuction = {
  __typename?: 'JobAuction';
  chargeType: JobChargeModel;
  description?: Maybe<Scalars['String']['output']>;
  destinationAddress?: Maybe<Address>;
  id: Scalars['ID']['output'];
  jobCategory: JobCategoryEnum;
  jobEndDate?: Maybe<Scalars['String']['output']>;
  jobEndTime?: Maybe<Scalars['String']['output']>;
  jobStartDate: Scalars['String']['output'];
  jobStartDateTimeIso: Scalars['String']['output'];
  jobStartTime: Scalars['String']['output'];
  jobStatus: JobStatusEnum;
  metrics?: Maybe<JobMetrics>;
  numberOfBids: Scalars['Int']['output'];
  originAddress: Address;
  parentId?: Maybe<Scalars['ID']['output']>;
  people?: Maybe<Array<Maybe<People>>>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
};

export type JobAuctionList = {
  __typename?: 'JobAuctionList';
  items: Array<Maybe<JobAuction>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export enum JobCategoryEnum {
  ChildCare = 'CHILD_CARE',
  ChildTransport = 'CHILD_TRANSPORT',
  CleaningServices = 'CLEANING_SERVICES',
  Electrician = 'ELECTRICIAN',
  EventPlaning = 'EVENT_PLANING',
  General = 'GENERAL',
  HandyMan = 'HANDY_MAN',
  LawnCare = 'LAWN_CARE',
  Moving = 'MOVING',
  Painting = 'PAINTING',
  Pickup = 'PICKUP',
  Plumber = 'PLUMBER'
}

export enum JobChargeModel {
  FixedPrice = 'FIXED_PRICE',
  Hourly = 'HOURLY'
}

export type JobInput = {
  chargeType: JobChargeModel;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationAddress?: InputMaybe<AddressInput>;
  jobCategory: JobCategoryEnum;
  jobEndDate?: InputMaybe<Scalars['String']['input']>;
  jobEndDateTimeIso?: InputMaybe<Scalars['String']['input']>;
  jobEndTime?: InputMaybe<Scalars['String']['input']>;
  jobStartDate: Scalars['String']['input'];
  jobStartDateTimeIso: Scalars['String']['input'];
  jobStartTime: Scalars['String']['input'];
  originAddress: AddressInput;
  people?: InputMaybe<Array<PeopleInput>>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Array<TaskInput>>;
};

export type JobMetrics = {
  __typename?: 'JobMetrics';
  jobActualHourDuration?: Maybe<Scalars['Int']['output']>;
  jobEstimateHourDuration?: Maybe<Scalars['Int']['output']>;
  jobTotalMinutes?: Maybe<Scalars['Int']['output']>;
};

export type JobReview = {
  __typename?: 'JobReview';
  comment?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type JobReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type JobScheduleEvent = {
  __typename?: 'JobScheduleEvent';
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  jobId: Scalars['ID']['output'];
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TaskStatus>;
};

export enum JobStatusEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  ExpiredNoWorker = 'EXPIRED_NO_WORKER',
  Open = 'OPEN'
}

export type JobsList = {
  __typename?: 'JobsList';
  items: Array<Maybe<Job>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  createdAt: Scalars['String']['output'];
  fromId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type MessageInput = {
  message: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBankToken: Scalars['Boolean']['output'];
  awardJob: Scalars['ID']['output'];
  bidOnJob: Scalars['ID']['output'];
  cancelJob: Scalars['ID']['output'];
  createExpense?: Maybe<Expense>;
  createInvoice?: Maybe<Invoice>;
  createJob: Job;
  createJobMessage: Scalars['ID']['output'];
  createJobReview: Scalars['ID']['output'];
  removeBank: Scalars['Boolean']['output'];
  removePaymentMethod: Scalars['ID']['output'];
  resetExpenseAnalysis?: Maybe<Expense>;
  sendCalendarInvite: Scalars['ID']['output'];
  updateContractorProfile: Scalars['ID']['output'];
  updateExpense?: Maybe<Expense>;
  updateInvoice?: Maybe<Invoice>;
  updateNotificationSetting: Scalars['Boolean']['output'];
  uploadContractorAvatarImage?: Maybe<Scalars['String']['output']>;
  upsertUserProfile: Scalars['ID']['output'];
};


export type MutationAddBankTokenArgs = {
  token: Scalars['ID']['input'];
};


export type MutationAwardJobArgs = {
  bidId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
};


export type MutationBidOnJobArgs = {
  amount: Scalars['Float']['input'];
  jobId: Scalars['ID']['input'];
};


export type MutationCancelJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateExpenseArgs = {
  input: ExpenseCreateInput;
  jobId: Scalars['ID']['input'];
};


export type MutationCreateInvoiceArgs = {
  expenseIds: Array<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
};


export type MutationCreateJobArgs = {
  job: JobInput;
};


export type MutationCreateJobMessageArgs = {
  input: MessageInput;
  jobId: Scalars['ID']['input'];
};


export type MutationCreateJobReviewArgs = {
  jobId: Scalars['ID']['input'];
  review: JobReviewInput;
};


export type MutationRemoveBankArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationResetExpenseAnalysisArgs = {
  expenseId: Scalars['ID']['input'];
};


export type MutationSendCalendarInviteArgs = {
  jobId: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
};


export type MutationUpdateContractorProfileArgs = {
  input: ContractorProfileInput;
};


export type MutationUpdateExpenseArgs = {
  expenseId: Scalars['ID']['input'];
  input: ExpenseUpdateInput;
};


export type MutationUpdateInvoiceArgs = {
  input: InvoiceUpdateInput;
  invoiceId: Scalars['ID']['input'];
};


export type MutationUpdateNotificationSettingArgs = {
  key: NotificationSettingEnum;
  value: Scalars['Boolean']['input'];
};


export type MutationUploadContractorAvatarImageArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertUserProfileArgs = {
  input: ProfileEditInput;
};

export enum NotificationSettingEnum {
  ChargeApplied = 'CHARGE_APPLIED',
  JobAssigned = 'JOB_ASSIGNED',
  JobMessage = 'JOB_MESSAGE'
}

export type NotificationSettingInput = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type People = {
  __typename?: 'People';
  age: Scalars['Int']['output'];
  gender: GenderEnum;
};

export type PeopleInput = {
  age: Scalars['Int']['input'];
  gender: GenderEnum;
};

export type ProfileEditInput = {
  address?: InputMaybe<AddressInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  echo?: Maybe<EchoResponse>;
  getAuctionsByDateAndType: JobAuctionList;
  getBanks?: Maybe<VopayBanksResponse>;
  getContractorInfo?: Maybe<ContractorPublicProfile>;
  getContractorPublicProfile?: Maybe<ContractorPublicProfile>;
  getJob?: Maybe<Job>;
  getJobsByDate: JobsList;
  getJobsByStatus: JobsList;
  getMyJobAuctions: JobsList;
  getPaymentIntent?: Maybe<StripePaymentIntentResponse>;
  getPaymentMethods?: Maybe<Array<Maybe<StripePaymentMethod>>>;
  getUserInfo: User;
  hasPaymentMethods?: Maybe<Scalars['Boolean']['output']>;
  listJobs: JobsList;
};


export type QueryEchoArgs = {
  input: Scalars['String']['input'];
};


export type QueryGetAuctionsByDateAndTypeArgs = {
  category: JobCategoryEnum;
  city: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetContractorPublicProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetJobsByDateArgs = {
  date: Scalars['Date']['input'];
};


export type QueryGetJobsByStatusArgs = {
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobStatusEnum>;
};


export type QueryGetMyJobAuctionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type RatingSummary = {
  __typename?: 'RatingSummary';
  averageStarRating?: Maybe<Scalars['Float']['output']>;
  fiveStarRatings?: Maybe<Scalars['Int']['output']>;
  fourStarRatings?: Maybe<Scalars['Int']['output']>;
  numberOfCompletedJobs?: Maybe<Scalars['Int']['output']>;
  oneStarRatings?: Maybe<Scalars['Int']['output']>;
  threeStarRatings?: Maybe<Scalars['Int']['output']>;
  twoStarRatings?: Maybe<Scalars['Int']['output']>;
};

export type StripePaymentIntentResponse = {
  __typename?: 'StripePaymentIntentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
};

export type Task = {
  __typename?: 'Task';
  completedAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: TaskStatus;
};

export type TaskInput = {
  description: Scalars['String']['input'];
};

export enum TaskStatus {
  Completed = 'COMPLETED',
  Open = 'OPEN'
}

export type TaxBreakdown = {
  __typename?: 'TaxBreakdown';
  contractorFee?: Maybe<Taxes>;
  serviceFee?: Maybe<Taxes>;
};

export type Taxes = {
  __typename?: 'Taxes';
  gst: Scalars['Float']['output'];
  hst: Scalars['Float']['output'];
  pst: Scalars['Float']['output'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  notificationSettings: Array<Maybe<UserNotificationSettings>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  key: NotificationSettingEnum;
  value: Scalars['Boolean']['output'];
};

export type VopayBanksResponse = {
  __typename?: 'VopayBanksResponse';
  accounts: Array<BankAccount>;
  embeddedUrl: EmbeddedUrl;
};


export type VopayBanksResponseEmbeddedUrlArgs = {
  redirectURL: Scalars['String']['input'];
};

export enum Weekdays {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  AnalysisFieldValue: ResolverTypeWrapper<AnalysisFieldValue>;
  BankAccount: ResolverTypeWrapper<BankAccount>;
  Bid: ResolverTypeWrapper<Bid>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BoundingBox: ResolverTypeWrapper<BoundingBox>;
  Charge: ResolverTypeWrapper<Charge>;
  ChargeBreakdown: ResolverTypeWrapper<ChargeBreakdown>;
  ContractorProfileInput: ContractorProfileInput;
  ContractorPublicProfile: ResolverTypeWrapper<ContractorPublicProfile>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  EchoResponse: ResolverTypeWrapper<EchoResponse>;
  EmbeddedUrl: ResolverTypeWrapper<EmbeddedUrl>;
  EnrichedAddress: ResolverTypeWrapper<EnrichedAddress>;
  EnrichedAddressRank: ResolverTypeWrapper<EnrichedAddressRank>;
  Expense: ResolverTypeWrapper<ExpenseItem>;
  ExpenseAnalysis: ResolverTypeWrapper<ExpenseAnalysis>;
  ExpenseAnalysisPage: ResolverTypeWrapper<ExpenseAnalysisPage>;
  ExpenseAnalysisStatus: ExpenseAnalysisStatus;
  ExpenseCreateInput: ExpenseCreateInput;
  ExpenseFilter: ExpenseFilter;
  ExpenseLineItem: ResolverTypeWrapper<ExpenseLineItem>;
  ExpenseType: ExpenseType;
  ExpenseUpdateInput: ExpenseUpdateInput;
  ExpenseVendor: ResolverTypeWrapper<ExpenseVendor>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GenderEnum: GenderEnum;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Invoice: ResolverTypeWrapper<InvoiceItem>;
  InvoiceStatus: InvoiceStatus;
  InvoiceUpdateInput: InvoiceUpdateInput;
  Job: ResolverTypeWrapper<Omit<Job, 'expenses' | 'invoices'> & { expenses: Array<ResolversTypes['Expense']>, invoices: Array<ResolversTypes['Invoice']> }>;
  JobAuction: ResolverTypeWrapper<JobAuction>;
  JobAuctionList: ResolverTypeWrapper<JobAuctionList>;
  JobCategoryEnum: JobCategoryEnum;
  JobChargeModel: JobChargeModel;
  JobInput: JobInput;
  JobMetrics: ResolverTypeWrapper<JobMetrics>;
  JobReview: ResolverTypeWrapper<JobReview>;
  JobReviewInput: JobReviewInput;
  JobScheduleEvent: ResolverTypeWrapper<Omit<JobScheduleEvent, 'job'> & { job?: Maybe<ResolversTypes['Job']> }>;
  JobStatusEnum: JobStatusEnum;
  JobsList: ResolverTypeWrapper<Omit<JobsList, 'items'> & { items: Array<Maybe<ResolversTypes['Job']>> }>;
  Message: ResolverTypeWrapper<Message>;
  MessageInput: MessageInput;
  Mutation: ResolverTypeWrapper<{}>;
  NotificationSettingEnum: NotificationSettingEnum;
  NotificationSettingInput: NotificationSettingInput;
  People: ResolverTypeWrapper<People>;
  PeopleInput: PeopleInput;
  ProfileEditInput: ProfileEditInput;
  Query: ResolverTypeWrapper<{}>;
  RatingSummary: ResolverTypeWrapper<RatingSummary>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StripePaymentIntentResponse: ResolverTypeWrapper<StripePaymentIntentResponse>;
  StripePaymentMethod: ResolverTypeWrapper<StripePaymentMethod>;
  Task: ResolverTypeWrapper<Task>;
  TaskInput: TaskInput;
  TaskStatus: TaskStatus;
  TaxBreakdown: ResolverTypeWrapper<TaxBreakdown>;
  Taxes: ResolverTypeWrapper<Taxes>;
  User: ResolverTypeWrapper<User>;
  UserNotificationSettings: ResolverTypeWrapper<UserNotificationSettings>;
  VopayBanksResponse: ResolverTypeWrapper<VopayBanksResponse>;
  Weekdays: Weekdays;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Address: Address;
  AddressInput: AddressInput;
  AnalysisFieldValue: AnalysisFieldValue;
  BankAccount: BankAccount;
  Bid: Bid;
  Boolean: Scalars['Boolean']['output'];
  BoundingBox: BoundingBox;
  Charge: Charge;
  ChargeBreakdown: ChargeBreakdown;
  ContractorProfileInput: ContractorProfileInput;
  ContractorPublicProfile: ContractorPublicProfile;
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  EchoResponse: EchoResponse;
  EmbeddedUrl: EmbeddedUrl;
  EnrichedAddress: EnrichedAddress;
  EnrichedAddressRank: EnrichedAddressRank;
  Expense: ExpenseItem;
  ExpenseAnalysis: ExpenseAnalysis;
  ExpenseAnalysisPage: ExpenseAnalysisPage;
  ExpenseCreateInput: ExpenseCreateInput;
  ExpenseLineItem: ExpenseLineItem;
  ExpenseUpdateInput: ExpenseUpdateInput;
  ExpenseVendor: ExpenseVendor;
  Float: Scalars['Float']['output'];
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  Invoice: InvoiceItem;
  InvoiceUpdateInput: InvoiceUpdateInput;
  Job: Omit<Job, 'expenses' | 'invoices'> & { expenses: Array<ResolversParentTypes['Expense']>, invoices: Array<ResolversParentTypes['Invoice']> };
  JobAuction: JobAuction;
  JobAuctionList: JobAuctionList;
  JobInput: JobInput;
  JobMetrics: JobMetrics;
  JobReview: JobReview;
  JobReviewInput: JobReviewInput;
  JobScheduleEvent: Omit<JobScheduleEvent, 'job'> & { job?: Maybe<ResolversParentTypes['Job']> };
  JobsList: Omit<JobsList, 'items'> & { items: Array<Maybe<ResolversParentTypes['Job']>> };
  Message: Message;
  MessageInput: MessageInput;
  Mutation: {};
  NotificationSettingInput: NotificationSettingInput;
  People: People;
  PeopleInput: PeopleInput;
  ProfileEditInput: ProfileEditInput;
  Query: {};
  RatingSummary: RatingSummary;
  String: Scalars['String']['output'];
  StripePaymentIntentResponse: StripePaymentIntentResponse;
  StripePaymentMethod: StripePaymentMethod;
  Task: Task;
  TaskInput: TaskInput;
  TaxBreakdown: TaxBreakdown;
  Taxes: Taxes;
  User: User;
  UserNotificationSettings: UserNotificationSettings;
  VopayBanksResponse: VopayBanksResponse;
};

export type AddressResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enrichedAddress?: Resolver<Maybe<ResolversTypes['EnrichedAddress']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  province?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unitNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisFieldValueResolvers<ContextType = Context, ParentType extends ResolversParentTypes['AnalysisFieldValue'] = ResolversParentTypes['AnalysisFieldValue']> = {
  boundingBox?: Resolver<Maybe<ResolversTypes['BoundingBox']>, ParentType, ContextType>;
  confidence?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankAccountResolvers<ContextType = Context, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = {
  bankName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  institutionNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maskedAccountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transitNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BidResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Bid'] = ResolversParentTypes['Bid']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  contractor?: Resolver<ResolversTypes['ContractorPublicProfile'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoundingBoxResolvers<ContextType = Context, ParentType extends ResolversParentTypes['BoundingBox'] = ResolversParentTypes['BoundingBox']> = {
  height?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  left?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  top?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargeResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Charge'] = ResolversParentTypes['Charge']> = {
  chargeBreakdown?: Resolver<ResolversTypes['ChargeBreakdown'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxBreakdown?: Resolver<ResolversTypes['TaxBreakdown'], ParentType, ContextType>;
  totalChargedAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChargeBreakdownResolvers<ContextType = Context, ParentType extends ResolversParentTypes['ChargeBreakdown'] = ResolversParentTypes['ChargeBreakdown']> = {
  contractorFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  systemFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractorPublicProfileResolvers<ContextType = Context, ParentType extends ResolversParentTypes['ContractorPublicProfile'] = ResolversParentTypes['ContractorPublicProfile']> = {
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pictureUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['RatingSummary']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type EchoResponseResolvers<ContextType = Context, ParentType extends ResolversParentTypes['EchoResponse'] = ResolversParentTypes['EchoResponse']> = {
  echo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmbeddedUrlResolvers<ContextType = Context, ParentType extends ResolversParentTypes['EmbeddedUrl'] = ResolversParentTypes['EmbeddedUrl']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrichedAddressResolvers<ContextType = Context, ParentType extends ResolversParentTypes['EnrichedAddress'] = ResolversParentTypes['EnrichedAddress']> = {
  addressLine1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLine2?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formatted?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  housenumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lon?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  postcode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['EnrichedAddressRank'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stateCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  suburb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnrichedAddressRankResolvers<ContextType = Context, ParentType extends ResolversParentTypes['EnrichedAddressRank'] = ResolversParentTypes['EnrichedAddressRank']> = {
  match_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpenseResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Expense'] = ResolversParentTypes['Expense']> = {
  analysis?: Resolver<Maybe<ResolversTypes['ExpenseAnalysis']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  presignedDownloadFile?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  presignedUploadFile?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ExpenseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpenseAnalysisResolvers<ContextType = Context, ParentType extends ResolversParentTypes['ExpenseAnalysis'] = ResolversParentTypes['ExpenseAnalysis']> = {
  pages?: Resolver<Array<ResolversTypes['ExpenseAnalysisPage']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ExpenseAnalysisStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpenseAnalysisPageResolvers<ContextType = Context, ParentType extends ResolversParentTypes['ExpenseAnalysisPage'] = ResolversParentTypes['ExpenseAnalysisPage']> = {
  amountDue?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  amountPaid?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['ExpenseLineItem']>, ParentType, ContextType>;
  pageNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tax?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['ExpenseVendor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpenseLineItemResolvers<ContextType = Context, ParentType extends ResolversParentTypes['ExpenseLineItem'] = ResolversParentTypes['ExpenseLineItem']> = {
  description?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  row?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  unitPrice?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpenseVendorResolvers<ContextType = Context, ParentType extends ResolversParentTypes['ExpenseVendor'] = ResolversParentTypes['ExpenseVendor']> = {
  address?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['AnalysisFieldValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expenses?: Resolver<Array<ResolversTypes['Expense']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceFinalizedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Charge']>>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvoiceStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Job'] = ResolversParentTypes['Job']> = {
  awardedTo?: Resolver<Maybe<ResolversTypes['ContractorPublicProfile']>, ParentType, ContextType>;
  awardedToId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  bids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Bid']>>>, ParentType, ContextType>;
  chargeType?: Resolver<ResolversTypes['JobChargeModel'], ParentType, ContextType>;
  charges?: Resolver<Maybe<Array<Maybe<ResolversTypes['Charge']>>>, ParentType, ContextType>;
  customerReview?: Resolver<Maybe<ResolversTypes['JobReview']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  expenses?: Resolver<Array<ResolversTypes['Expense']>, ParentType, ContextType, Partial<JobExpensesArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType, Partial<JobInvoicesArgs>>;
  jobCategory?: Resolver<ResolversTypes['JobCategoryEnum'], ParentType, ContextType>;
  jobEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobStartDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStartDateTimeIso?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStartTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStatus?: Resolver<ResolversTypes['JobStatusEnum'], ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['Message']>>>, ParentType, ContextType>;
  metrics?: Resolver<Maybe<ResolversTypes['JobMetrics']>, ParentType, ContextType>;
  originAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  people?: Resolver<Maybe<Array<Maybe<ResolversTypes['People']>>>, ParentType, ContextType>;
  specialInstructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Task']>>>, ParentType, ContextType>;
  winningBid?: Resolver<Maybe<ResolversTypes['Bid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobAuctionResolvers<ContextType = Context, ParentType extends ResolversParentTypes['JobAuction'] = ResolversParentTypes['JobAuction']> = {
  chargeType?: Resolver<ResolversTypes['JobChargeModel'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobCategory?: Resolver<ResolversTypes['JobCategoryEnum'], ParentType, ContextType>;
  jobEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobStartDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStartDateTimeIso?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStartTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobStatus?: Resolver<ResolversTypes['JobStatusEnum'], ParentType, ContextType>;
  metrics?: Resolver<Maybe<ResolversTypes['JobMetrics']>, ParentType, ContextType>;
  numberOfBids?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  originAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  people?: Resolver<Maybe<Array<Maybe<ResolversTypes['People']>>>, ParentType, ContextType>;
  specialInstructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Task']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobAuctionListResolvers<ContextType = Context, ParentType extends ResolversParentTypes['JobAuctionList'] = ResolversParentTypes['JobAuctionList']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['JobAuction']>>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobMetricsResolvers<ContextType = Context, ParentType extends ResolversParentTypes['JobMetrics'] = ResolversParentTypes['JobMetrics']> = {
  jobActualHourDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobEstimateHourDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTotalMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobReviewResolvers<ContextType = Context, ParentType extends ResolversParentTypes['JobReview'] = ResolversParentTypes['JobReview']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobScheduleEventResolvers<ContextType = Context, ParentType extends ResolversParentTypes['JobScheduleEvent'] = ResolversParentTypes['JobScheduleEvent']> = {
  endDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  job?: Resolver<Maybe<ResolversTypes['Job']>, ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['TaskStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsListResolvers<ContextType = Context, ParentType extends ResolversParentTypes['JobsList'] = ResolversParentTypes['JobsList']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['Job']>>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addBankToken?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddBankTokenArgs, 'token'>>;
  awardJob?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationAwardJobArgs, 'bidId' | 'jobId'>>;
  bidOnJob?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationBidOnJobArgs, 'amount' | 'jobId'>>;
  cancelJob?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationCancelJobArgs, 'id'>>;
  createExpense?: Resolver<Maybe<ResolversTypes['Expense']>, ParentType, ContextType, RequireFields<MutationCreateExpenseArgs, 'input' | 'jobId'>>;
  createInvoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<MutationCreateInvoiceArgs, 'expenseIds' | 'jobId'>>;
  createJob?: Resolver<ResolversTypes['Job'], ParentType, ContextType, RequireFields<MutationCreateJobArgs, 'job'>>;
  createJobMessage?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationCreateJobMessageArgs, 'input' | 'jobId'>>;
  createJobReview?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationCreateJobReviewArgs, 'jobId' | 'review'>>;
  removeBank?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveBankArgs, 'id'>>;
  removePaymentMethod?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationRemovePaymentMethodArgs, 'paymentId'>>;
  resetExpenseAnalysis?: Resolver<Maybe<ResolversTypes['Expense']>, ParentType, ContextType, RequireFields<MutationResetExpenseAnalysisArgs, 'expenseId'>>;
  sendCalendarInvite?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationSendCalendarInviteArgs, 'jobId' | 'ownerId'>>;
  updateContractorProfile?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationUpdateContractorProfileArgs, 'input'>>;
  updateExpense?: Resolver<Maybe<ResolversTypes['Expense']>, ParentType, ContextType, RequireFields<MutationUpdateExpenseArgs, 'expenseId' | 'input'>>;
  updateInvoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType, RequireFields<MutationUpdateInvoiceArgs, 'input' | 'invoiceId'>>;
  updateNotificationSetting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateNotificationSettingArgs, 'key' | 'value'>>;
  uploadContractorAvatarImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationUploadContractorAvatarImageArgs>>;
  upsertUserProfile?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationUpsertUserProfileArgs, 'input'>>;
};

export type PeopleResolvers<ContextType = Context, ParentType extends ResolversParentTypes['People'] = ResolversParentTypes['People']> = {
  age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['GenderEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  echo?: Resolver<Maybe<ResolversTypes['EchoResponse']>, ParentType, ContextType, RequireFields<QueryEchoArgs, 'input'>>;
  getAuctionsByDateAndType?: Resolver<ResolversTypes['JobAuctionList'], ParentType, ContextType, RequireFields<QueryGetAuctionsByDateAndTypeArgs, 'category' | 'city' | 'date'>>;
  getBanks?: Resolver<Maybe<ResolversTypes['VopayBanksResponse']>, ParentType, ContextType>;
  getContractorInfo?: Resolver<Maybe<ResolversTypes['ContractorPublicProfile']>, ParentType, ContextType>;
  getContractorPublicProfile?: Resolver<Maybe<ResolversTypes['ContractorPublicProfile']>, ParentType, ContextType, RequireFields<QueryGetContractorPublicProfileArgs, 'id'>>;
  getJob?: Resolver<Maybe<ResolversTypes['Job']>, ParentType, ContextType, RequireFields<QueryGetJobArgs, 'id'>>;
  getJobsByDate?: Resolver<ResolversTypes['JobsList'], ParentType, ContextType, RequireFields<QueryGetJobsByDateArgs, 'date'>>;
  getJobsByStatus?: Resolver<ResolversTypes['JobsList'], ParentType, ContextType, Partial<QueryGetJobsByStatusArgs>>;
  getMyJobAuctions?: Resolver<ResolversTypes['JobsList'], ParentType, ContextType, Partial<QueryGetMyJobAuctionsArgs>>;
  getPaymentIntent?: Resolver<Maybe<ResolversTypes['StripePaymentIntentResponse']>, ParentType, ContextType>;
  getPaymentMethods?: Resolver<Maybe<Array<Maybe<ResolversTypes['StripePaymentMethod']>>>, ParentType, ContextType>;
  getUserInfo?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  hasPaymentMethods?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  listJobs?: Resolver<ResolversTypes['JobsList'], ParentType, ContextType, Partial<QueryListJobsArgs>>;
};

export type RatingSummaryResolvers<ContextType = Context, ParentType extends ResolversParentTypes['RatingSummary'] = ResolversParentTypes['RatingSummary']> = {
  averageStarRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fiveStarRatings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fourStarRatings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfCompletedJobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  oneStarRatings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  threeStarRatings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  twoStarRatings?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StripePaymentIntentResponseResolvers<ContextType = Context, ParentType extends ResolversParentTypes['StripePaymentIntentResponse'] = ResolversParentTypes['StripePaymentIntentResponse']> = {
  clientSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StripePaymentMethodResolvers<ContextType = Context, ParentType extends ResolversParentTypes['StripePaymentMethod'] = ResolversParentTypes['StripePaymentMethod']> = {
  brand?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastFour?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = {
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TaskStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxBreakdownResolvers<ContextType = Context, ParentType extends ResolversParentTypes['TaxBreakdown'] = ResolversParentTypes['TaxBreakdown']> = {
  contractorFee?: Resolver<Maybe<ResolversTypes['Taxes']>, ParentType, ContextType>;
  serviceFee?: Resolver<Maybe<ResolversTypes['Taxes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxesResolvers<ContextType = Context, ParentType extends ResolversParentTypes['Taxes'] = ResolversParentTypes['Taxes']> = {
  gst?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hst?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pst?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = Context, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationSettings?: Resolver<Array<Maybe<ResolversTypes['UserNotificationSettings']>>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserNotificationSettingsResolvers<ContextType = Context, ParentType extends ResolversParentTypes['UserNotificationSettings'] = ResolversParentTypes['UserNotificationSettings']> = {
  key?: Resolver<ResolversTypes['NotificationSettingEnum'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VopayBanksResponseResolvers<ContextType = Context, ParentType extends ResolversParentTypes['VopayBanksResponse'] = ResolversParentTypes['VopayBanksResponse']> = {
  accounts?: Resolver<Array<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  embeddedUrl?: Resolver<ResolversTypes['EmbeddedUrl'], ParentType, ContextType, RequireFields<VopayBanksResponseEmbeddedUrlArgs, 'redirectURL'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = Context> = {
  Address?: AddressResolvers<ContextType>;
  AnalysisFieldValue?: AnalysisFieldValueResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  Bid?: BidResolvers<ContextType>;
  BoundingBox?: BoundingBoxResolvers<ContextType>;
  Charge?: ChargeResolvers<ContextType>;
  ChargeBreakdown?: ChargeBreakdownResolvers<ContextType>;
  ContractorPublicProfile?: ContractorPublicProfileResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  EchoResponse?: EchoResponseResolvers<ContextType>;
  EmbeddedUrl?: EmbeddedUrlResolvers<ContextType>;
  EnrichedAddress?: EnrichedAddressResolvers<ContextType>;
  EnrichedAddressRank?: EnrichedAddressRankResolvers<ContextType>;
  Expense?: ExpenseResolvers<ContextType>;
  ExpenseAnalysis?: ExpenseAnalysisResolvers<ContextType>;
  ExpenseAnalysisPage?: ExpenseAnalysisPageResolvers<ContextType>;
  ExpenseLineItem?: ExpenseLineItemResolvers<ContextType>;
  ExpenseVendor?: ExpenseVendorResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  Job?: JobResolvers<ContextType>;
  JobAuction?: JobAuctionResolvers<ContextType>;
  JobAuctionList?: JobAuctionListResolvers<ContextType>;
  JobMetrics?: JobMetricsResolvers<ContextType>;
  JobReview?: JobReviewResolvers<ContextType>;
  JobScheduleEvent?: JobScheduleEventResolvers<ContextType>;
  JobsList?: JobsListResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  People?: PeopleResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RatingSummary?: RatingSummaryResolvers<ContextType>;
  StripePaymentIntentResponse?: StripePaymentIntentResponseResolvers<ContextType>;
  StripePaymentMethod?: StripePaymentMethodResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TaxBreakdown?: TaxBreakdownResolvers<ContextType>;
  Taxes?: TaxesResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserNotificationSettings?: UserNotificationSettingsResolvers<ContextType>;
  VopayBanksResponse?: VopayBanksResponseResolvers<ContextType>;
};

